import gql from "graphql-tag";

export const LOGIN = gql`
mutation UserLogin($clientId: String!, $username: String!, $password: String!) {
  login(clientID: $clientId, username: $username, password: $password) {
    AuthenticationResult {
      AccessToken
      ExpiresIn
      IdToken
      RefreshToken
    }
    ChallengeParameters {
      CODE_DELIVERY_DELIVERY_MEDIUM
      CODE_DELIVERY_DESTINATION
      USER_ID_FOR_SRP
    }
    MFAEnabled
    Session
    Error {
      message
      error
    }
  }
}
`;

export const ACCOUNT_DEACTIVATION = gql`
  mutation AccountDeactivation($username: String!, $org_id: String!) {
    accountDeactivation(username: $username, org_id: $org_id) {
      description
      status
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($username: String!) {
    forgotPassword(username: $username) {
      text
      Error {
        message
        error
      }
    }
  }
`;

export const CONFIRM_FORGOT_PASSWORD = gql`
mutation ConfirmForgotPassword($code: String!, $username: String!, $password: String!) {
  confirmForgotPassword(code: $code, username: $username, password: $password) {
    text
    Error {
      message
      error
    }
  }
}
`;

export const RESPONDTOAUTHCHALLENGESMS = gql`
mutation RespondAuthChallengeSMS($smsMfaCode: String!, $username: String!, $clientId: String!, $session: String!) {
  respondToAuthChallengeSMS(SMS_MFA_CODE: $smsMfaCode, USERNAME: $username, clientID: $clientId, session: $session) {
    accessToken {
      expiry
      jwt
    }
    refreshToken
    Error {
      message
      error
    }
  }
}
`

export const SIGN_UP = gql`
mutation SignUp($input: ISignUpInputGQL!) {
  signUp(input: $input) {
    text
    username
    Error {
      message
      error
    }
  }
}
`;

export const SIGN_UP_DRIVER = gql`
mutation signUpDriver($input: ISignUpDriverInputGQL!) {
  signUpDriver(input: $input) {
    text
    username
    Error {
      message
      error
    }
  }
}
`;

export const CONFIRM_SIGN_UP = gql`
mutation ConfirmSignUp($code: String!, $email: String!) {
  confirmSignUp(code: $code, email: $email) {
    text
    Error {
      message
      error
    }
  }
}
`;

export const VERIFICATION_CODE = gql`
mutation VerificationCode($accessToken: String!, $attributeName: String!) {
  verificationCode(accessToken: $accessToken, attributeName: $attributeName) {
    text
    Error {
      message
      error
    }
  }
}
`;

export const VERIFY_OTP = gql`
mutation VerifyOTP($accessToken: String!, $attributeName: String!, $code: String!) {
  verifyOTP(accessToken: $accessToken, attributeName: $attributeName, code: $code) {
    text
    Error {
      message
      error
    }
  }
}
`;

export const RESEND_OTP = gql`
mutation ResendOTP($clientID: String!, $username: String!) {
  resendOTPConfirmation(clientID: $clientID, username: $username) {
    text
    Error {
      message
      error
    }
  }
}
`;

export const RESEND_OTP_RAW = `
mutation ResendOTP($clientID: String!, $username: String!) {
  resendOTPConfirmation(clientID: $clientID, username: $username) {
    text
    Error {
      message
      error
    }
  }
}
`;

export const ADMIN_LOGIN_RAW = `
mutation adminLogin($clientId: String!, $username: String!, $password: String!) {
  adminLogin(clientID: $clientId, username: $username, password: $password) {
    AuthenticationResult {
      AccessToken
      ExpiresIn
      IdToken
      RefreshToken
    }
    Error {
      message
      error
    }
  }
}
`;

export const ADD_USER_TO_GROUP = gql`
mutation AdminAddUserToGroup($input: IAdminAddUserToGroupInputGQL!) {
  adminAddUserToGroup(input: $input) {
    text
    Error {
      message
      error
    }
  }
}
`;
